<template>
    <div>
        <b-field :type="'is-'+messageClass"
        :message="message">
            <b-input
            :loading="loading"
            icon="percent"
            rounded
            size="is-large"
            v-model="codeSearch"
            maxlength="10"
            @input="getCouponRequest">
            </b-input>
        </b-field>
    </div>
</template>

<script>
import { getHandler, debounce } from '../../../../services/http'
export default {
    props:{
        couponFind:{
            type:String,
            default:""
        },
        totalAmount:{
            type:Number,
            default:0
        }
    },
    data(){
        return{
            loading:false,
            coupon:{},
            codeSearch:"",
            message:"",
            messageClass:""
        }
    },
    methods:{
        getCouponRequest: debounce(async function(){
            var url = this.couponFind + "?q=" + this.codeSearch
            var response = await getHandler(url, {error:false, success:false})
            
            if(response.active && response.minimumAmmountUsd < this.totalAmount){
                this.$emit("couponCodeFound", response)
                console.log(response)
                this.message = "Cupon aplicado"
                this.messageClass = "success"
            }
            else if (response.minimumAmmountUsd > this.totalAmount){
                this.$emit("clearCoupon")
                this.message = "Cupon aplicable para ordenes mayores de " + response.minimumAmmount
                this.messageClass = "danger"
            }
            else if (!this.codeSearch.length){
                this.$emit("clearCoupon")
                this.message = ""
                this.messageClass = ""
            }
            else{
                this.$emit("clearCoupon")
                this.message = "No encontramos ese cupon."
                this.messageClass = "danger"
            }
        }, 1000)
    }
}
</script>

<style lang="stylus">

</style>